(function () {
  'use strict'

  const SCROLL_THRESHOLD = 50
  const POSITION_COUNT = 5

  const container = document.querySelector('.confetti-container')

  // Nothing to do if the confetti isn't on the page, or it's already hidden
  // (e.g. the prefers-reduced-motion guard sets `display: none`).
  if (!container || getComputedStyle(container).display === 'none') {
    return
  }

  // Fisher-Yates in-place shuffle.
  function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      const tmp = arr[i]
      arr[i] = arr[j]
      arr[j] = tmp
    }
    return arr
  }

  // The images are placeholders: assign them to the fixed positions at random on every
  // load. There are POSITION_COUNT spots. If there are fewer images we fill that many
  // random spots; if there are more we show a random POSITION_COUNT of them. Any badge
  // left without a `confetti-pos-*` class stays hidden (see the CSS).
  const badges = Array.prototype.slice.call(container.children)
  const positions = shuffle([1, 2, 3, 4, 5])
  const order = shuffle(badges.slice())
  const count = Math.min(order.length, POSITION_COUNT)
  for (let i = 0; i < count; i++) {
    order[i].classList.add('confetti-pos-' + positions[i])
  }

  // Reveal only after positions are assigned, so the pop plays once from a fixed layout
  // and never visibly reshuffles mid-animation.
  container.classList.add('confetti-play')

  // The confetti is a brief, decorative celebration that self-clears via CSS after ~2s.
  // If the shopper starts scrolling, that signals intent to engage with the page, so
  // remove the confetti early to get it out of their way.
  function handleScroll() {
    if (window.scrollY <= SCROLL_THRESHOLD) {
      return
    }
    container.remove()
    window.removeEventListener('scroll', handleScroll)
  }

  window.addEventListener('scroll', handleScroll, { passive: true })
})()
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="726e1c72-6bf0-5881-b7bd-6e4d04264b8f")}catch(e){}}();
//# debugId=726e1c72-6bf0-5881-b7bd-6e4d04264b8f
